import React from "react";

import { CheckIcon } from "./icons";
import { CoButton } from "./Button";
import { VideoPlaceholder } from "./VideoPlaceholder";

// "Here's what to do, here's why it's safe, tell us when it's done." Used for
// the steps where the real work happens outside Zournal.
export function ExplainerConfirm({
  title,
  explainer,
  videoCaption,
  videoId,
  reassurance,
  confirmLabel,
  confirmed,
  onConfirm,
  children,
}: {
  title: string;
  explainer: string;
  videoCaption?: string;
  videoId?: string;
  reassurance?: string;
  confirmLabel: string;
  confirmed: boolean;
  onConfirm: () => void;
  children?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-4 rounded-lg border p-5">
      <div className="flex flex-col gap-1">
        <h3 className="text-base font-medium">{title}</h3>
        <p className="text-sm text-muted-foreground">{explainer}</p>
      </div>

      {children}

      {videoCaption && <VideoPlaceholder caption={videoCaption} videoId={videoId} />}

      {reassurance && <p className="text-xs text-muted-foreground">{reassurance}</p>}

      {confirmed ? (
        <p className="flex items-center gap-2 text-sm font-medium text-primary">
          <CheckIcon className="size-4" />
          Confirmed
        </p>
      ) : (
        <CoButton className="w-fit" onClick={onConfirm}>
          {confirmLabel}
        </CoButton>
      )}
    </div>
  );
}
